import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Title = styled(Link)`
    text-decoration: none;
    font-size: 0.85rem;
`;

export const BackgroundCard = styled.div`
    border-radius: 10px;
`;

export const Id = styled.div`
    font-size: 0.85rem;
    background-color: transparent;
    opacity: 0.5;
`;
